var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from 'react';
import format from 'string-format';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { useDeleteResourceSmartgroup } from '@/api/smf-resources/smartgroups';
import { ConfirmationModal } from '@/components/confirmation-modal';
export function ResourceFilterDeleteModal(_a) {
    var open = _a.open, onClose = _a.onClose, onDelete = _a.onDelete, selectedFilter = _a.selectedFilter;
    var t = useTranslation().t;
    var _b = useDeleteResourceSmartgroup(), mutate = _b.mutate, isPending = _b.isPending;
    var handleDelete = useCallback(function () {
        mutate(selectedFilter.id, {
            onSuccess: function () {
                onDelete();
            },
        });
    }, [mutate, selectedFilter.id, onDelete]);
    return (_jsx(ConfirmationModal, __assign({ title: t('components.resources.filter.delete_modal.title'), confirmLabel: t('global.buttons.delete'), onClose: onClose, onConfirm: handleDelete, open: open, disabled: isPending }, { children: _jsxs(Box, __assign({ sx: { display: 'flex', flexDirection: 'row', gap: 1 } }, { children: [_jsx(Box, { children: _jsx(ErrorOutlineIcon, { color: "warning" }) }), _jsx(Box, { children: _jsx(Typography, __assign({ component: "p", variant: "body1", marginBottom: 0.5, whiteSpace: "pre-line" }, { children: format(t('components.resources.filter.delete_modal.message'), selectedFilter.name) })) })] })) })));
}
